export default __webpack_public_path__ + "static/media/locked.af22dba4.svg";